import React from 'react';
import { Links, StyledLink, Copyright } from './styles';

const WarnerFooter: React.FC = () => {
  return (
    <Links>
      <Copyright>© 2022 Warner Music Inc.</Copyright>
      <StyledLink
        href="https://privacy.wmg.com/ecom/privacy-policy"
        target="_blank"
      >
        Privacy Policy
      </StyledLink>
      <StyledLink href="https://www.wmg.com/terms-of-use" target="_blank">
        Terms of Use
      </StyledLink>
      <StyledLink
        href="https://www.wminewmedia.com/cookies-policy/en/"
        target="_blank"
      >
        Cookies Policy
      </StyledLink>
      <StyledLink className="ot-sdk-show-settings">Cookies Settings</StyledLink>
    </Links>
  );
};

export default WarnerFooter;
